import { ActionType } from "../actions/ActionTypes";

interface TestimonialState {
    loading: boolean;
    success: boolean;
    error: string | null;
}

const initialState: TestimonialState = {
    loading: false,
    success: false,
    error: null,
};

const testimonialReducer = (state = initialState, action: any): TestimonialState => {
    switch (action.type) {
        case ActionType.SUBMIT_TESTIMONIAL_INIT:
            return {
                ...state,
                loading: true,
                success: false,
                error: null
            };

        case ActionType.SUBMIT_TESTIMONIAL_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true
            };

        case ActionType.SUBMIT_TESTIMONIAL_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default testimonialReducer;
